<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-building"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<div class="page-body">
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-list"></i>
      </div>
      <span class="card-header-title">{{ texts.tabela_de_empresas }}</span>
    </div>

    <div class="card-content">
      <!-- Barra de busca -->
      <div class="search-bar">
        <p-iconField iconPosition="right" class="search-field">
          <p-inputIcon styleClass="pi pi-search" />
          <input pInputText type="text"
            [placeholder]="placeholders.pesquisar"
            [(ngModel)]="filterName"
            (ngModelChange)="onSearchChange($event)" />
        </p-iconField>
      </div>

      <!-- Tabela -->
      <p-table [value]="empresas" [loading]="loading"
        [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 32%">{{ labels.nome }}</th>
            <th style="width: 18%">{{ labels.ruc }}</th>
            <th style="width: 25%">{{ labels.email }}</th>
            <th style="width: 17%">{{ labels.telefone }}</th>
            <th style="width: 8%">{{ labels.acoes }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-empresa>
          <tr class="empresa-row" (click)="selecionarEmpresa(empresa)">
            <td>
              <span class="empresa-nome">{{ empresa.nome }}</span>
            </td>
            <td>{{ empresa.ruc || '-' }}</td>
            <td>{{ empresa.email || '-' }}</td>
            <td>{{ (empresa | formatPhone) || '-' }}</td>
            <td class="actions" (click)="$event.stopPropagation()">
              <button pButton icon="pi pi-arrow-right-arrow-left"
                class="p-button-text p-button-rounded p-button-sm action-btn select-btn"
                [pTooltip]="tooltips.selecionar" tooltipPosition="top"
                (click)="selecionarEmpresa(empresa)">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ texts.nenhuma_empresa }}</div>
                <div class="text-gray-400 text-sm mt-1">{{ texts.dica_busca }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="5" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ texts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <!-- Paginacao -->
      <div class="pagination-container">
        <div>
          <p-paginator (onPageChange)="onPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"
            [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>

<!-- Modal de Confirmacao de Troca de Empresa (Wave Design) -->
<p-dialog [(visible)]="confirmDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-building" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_troca }}</p>
    <p class="empresa-destaque" *ngIf="empresaSelecionada">{{ empresaSelecionada.nome }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      [disabled]="trocandoEmpresa" (click)="cancelarTroca()"></button>
    <button pButton [label]="botoes.confirmar" icon="pi pi-check"
      [loading]="trocandoEmpresa" (click)="confirmarTroca()"></button>
  </ng-template>
</p-dialog>
